import React from 'react';
import { Button, Menu, Icon } from 'semantic-ui-react';

const Pagination = ({
  page,
  pages,
  cropURL,
  croppable,
  onFirst,
  onPrevious,
  onNext,
  onLast,
  editDisabled,
  toggleCropMode
}) => {
  const firstButton = (
    <Button
      basic
      icon={<Icon inverted name="double angle left" size="big" color="grey" />}
      onClick={onFirst}
      disabled={page === 1}
    />
  );
  const previousButton = (
    <Button
      basic
      icon={<Icon inverted name="angle left" size="big" color="grey" />}
      onClick={onPrevious}
      disabled={page === 1}
    />
  );
  const nextButton = (
    <Button
      basic
      icon={<Icon inverted name="angle right" size="big" color="grey" />}
      onClick={onNext}
      disabled={page === pages}
    />
  );
  const lastButton = (
    <Button
      basic
      icon={<Icon inverted name="double angle right" size="big" color="grey" />}
      onClick={onLast}
      disabled={page === pages}
    />
  );
  const cropButton = (
    <Button
      id="cropButton"
      basic
      icon={
        <Icon
          inverted
          name="crop"
          size="big"
          color={cropURL ? 'red' : 'grey'}
        />
      }
      onClick={toggleCropMode}
      disabled={!croppable || editDisabled}
    />
  );

  return (
    <Menu inverted style={{ backgroundColor: 'inherit' }}>
      {firstButton}
      {previousButton}
      {nextButton}
      {lastButton}
      {cropButton}
    </Menu>
  );
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/component/DocumentPreview/PDFPreview/Pagination.js